module.exports = __webpack_public_path__ + "img/mk.79704f33.svg";